<template>
  <div style="display: none">
    <canvas ref="canvasBack"></canvas>
  </div>
</template>

<script>
export default {
  props: ["worker"],

  methods: {
    async generateBackImage() {
      try {
        const canvas = this.$refs.canvasBack;
        const ctx = canvas.getContext("2d");

        // Dimensiones del fotocheck (600x1000px - optimizado)
        canvas.width = 650;
        canvas.height = 1050;

        // Fondo blanco
        ctx.fillStyle = "#FFFFFF";
        ctx.fillRect(0, 0, canvas.width, canvas.height);
        await this.drawLogo(ctx);
        // Marca de agua de fondo (logoSunDrive)
        await this.drawWatermark(ctx);

        // Texto de advertencia centrado
        ctx.fillStyle = "#529518"; // COLOR DE FUENTE
        ctx.font = "27px Arial";
        ctx.textAlign = "center";

        const warningText = "El uso de este fotocheck es personal";
        const warningText2 = "e intransferible, en caso de perdida o";
        const warningText3 = "extravío devolver a:";

        ctx.fillText(warningText, 325, 289);
        ctx.fillText(warningText2, 325, 317);
        ctx.fillText(warningText3, 325, 345);

        // Información de la empresa
        ctx.font = "34px Arial";
        ctx.fillText("Planta Tambogrande", 325, 465);

        ctx.font = "22.5px Arial ExtraLight";
        ctx.fillText("Carretera Tambogrande - Las Lomas Km 1077+179M", 325, 503);
        ctx.font = "23px Arial ExtraLight";
        ctx.fillText("(+51) 73-310409 / (+51) 73-313709", 325, 535);

        // ctx.fillStyle = "#6BA43A";
        ctx.font = "bold 20px Arial";
        ctx.fillText("RUC 20329725431", 325, 575);
        ctx.fillText("SUNSHINE EXPORT S.A.C", 325, 600);

        // URL del sitio web
        ctx.fillStyle = "#BF0101";
        ctx.font = "bold 28px Arial";
        ctx.fillText("www.sunshineperu.com", 325, 870);

        // Barra naranja inferior más delgada (igual que el frontal)
        const barHeight = 68;
        const gradient = ctx.createLinearGradient(0, 1050 - barHeight, 650, 1050);
        gradient.addColorStop(0, "#D94A16");
        gradient.addColorStop(1, "#F6A121");

        ctx.fillStyle = gradient;
        ctx.fillRect(0, 1050 - barHeight, 650, barHeight);

        return canvas.toDataURL("image/png");
      } catch (error) {
        console.error("Error generando reverso:", error);
        return null;
      }
    },
    async drawLogo(ctx) {
      // Logo Sunshine (usando require como en PdfVacation)
      return new Promise((resolve) => {
        const logo = new Image();
        logo.crossOrigin = "Anonymous";
        logo.onload = () => {
          // Dibujar logo centrado y más grande
          ctx.drawImage(logo, 80, 70, 490, 105); // (logo , top-left x,y , width, height)
          resolve();
        };
        logo.onerror = () => {
          console.warn("Error cargando logo");
          resolve();
        };
        // Usar require para obtener la ruta correcta
        try {
          logo.src = require("@/assets/logo_sp.png");
        } catch (e) {
          // Fallback a ruta estática
          logo.src = "/static/logo_sp.png";
        }
      });
    },
    async drawWatermark(ctx) {
      // Marca de agua con logoSunDrive
      return new Promise((resolve) => {
        const watermark = new Image();
        watermark.crossOrigin = "Anonymous";
        watermark.onload = () => {
          // Guardar estado del contexto
          ctx.save();

          // Configurar opacidad para marca de agua
          ctx.globalAlpha = 0.15;

          // Dibujar marca de agua centrada y grande
          const wmWidth = 550;
          const wmHeight = 550;
          const wmX = (650 - wmWidth) / 2;
          const wmY = (1050 - wmHeight) / 2;

          ctx.drawImage(watermark, wmX, wmY, wmWidth, wmHeight);

          // Restaurar estado del contexto
          ctx.restore();
          resolve();
        };
        watermark.onerror = () => {
          console.warn("Error cargando marca de agua");
          resolve();
        };
        // Intentar cargar logoSunDrive
        try {
          watermark.src = require("@/assets/logoSunDrive.png");
        } catch (e) {
          // Fallback a ruta estática
          watermark.src = "/static/logoSunDrive.png";
        }
      });
    },
  },
};
</script>

<style scoped>
canvas {
  border: 1px solid #ddd;
}
</style>
